import React, { useState } from "react";
import { TextField, Button, Alert } from "@mui/material";
import styles from "./ContactDetails.module.css";
import Logo from "../components/Logo";
import SideBackground from "../components/SideBackground";
import api from "../API/axios";
import NotificationSnackbar from "../components/NotificationSnackbar";
import useNotification from "../hooks/useNotification";

export default function TwoFactorVerify() {
  const { notification, showNotification, hideNotification } =
    useNotification();
  const [form, setForm] = useState({
    verificationCode: "",
  });
  const [errors, setErrors] = useState({
    verificationCode: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });

    // Clear errors when user starts typing
    if (errors[name]) {
      setErrors({ ...errors, [name]: "" });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Reset errors
    setErrors({ verificationCode: "" });

    // Validate verification code
    if (!form.verificationCode || form.verificationCode.length !== 6) {
      showNotification(
        "Please enter a valid 6-digit verification code.",
        "error"
      );
      return;
    }

    // Get parameters from URL
    const params = new URLSearchParams(window.location.search);
    const verificationToken = params.get("token");
    // const method = params.get("method");

    if (!verificationToken) {
      showNotification("Verification token missing.", "error");
      return;
    }

    try {
      await api.post("/TwoFactor/verify-email", {
        token: verificationToken,
        verificationCode: form.verificationCode,
      });

      // Redirect to bypass codes page
      window.location.href = `/bypass-codes?token=${verificationToken}`;
    } catch (err) {
      console.error(err);
      showNotification(
  "The verification code is incorrect or has expired.",
  "error"
);

    }
  };

  // Get param from URL params
  const params = new URLSearchParams(window.location.search);
  const email = params.get("email");

  return (
    <div className={styles.contactDetailsRoot}>
      <div className={styles.contactDetailsLeft}>
        <div className={styles.contactDetailsLogoWrap}>
          <Logo />
        </div>
        <form className={styles.contactDetailsForm} onSubmit={handleSubmit}>
          <h2>Complete Setup</h2>
          <div style={{ width: "100%", textAlign: "center", marginBottom: 12 }}>
            <h3 style={{ margin: 0, fontWeight: 500 }}>Email Verification</h3>
          </div>
          <div
            style={{
              width: "100%",
              textAlign: "center",
              marginBottom: 24,
              color: "#555",
              fontSize: "1rem",
            }}
          >
            A 6-digit verification code has been sent to your email address.
            Please enter the code below to complete your 2-factor authentication
            setup.
          </div>

          {/* Verification code error */}
          {errors.verificationCode && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {errors.verificationCode}
            </Alert>
          )}

          <div
            style={{
              margin: "0 auto 24px auto",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <TextField
              type="text"
              label="Verification Code"
              name="verificationCode"
              value={form.verificationCode}
              onChange={handleChange}
              required
              autoFocus
              error={!!errors.verificationCode}
              helperText="Enter the 6-digit code sent to your email"
              inputProps={{ maxLength: 6, pattern: "[0-9]*" }}
              sx={{ minWidth: 200, maxWidth: 300, width: "100%" }}
            />
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              width: "100%",
              marginTop: "20px",
            }}
          >
            <Button
              type="submit"
              variant="contained"
              color="error"
              size="large"
              sx={{ minWidth: 140, maxWidth: 180, width: "50%" }}
            >
              Continue
            </Button>
          </div>
        </form>
      </div>
      <SideBackground>
        <div className={styles.contactDetailsBgOverlay}></div>
      </SideBackground>

      {/* Notification Snackbar */}
      <NotificationSnackbar
        open={notification.open}
        message={notification.message}
        severity={notification.severity}
        onClose={hideNotification}
      />
    </div>
  );
}
